module.exports = {
  eventCategory: 'Editor UI | Tool Menu | icons | stickers',

  render: function () {
    this.trackEvent({
      eventAction: 'show',
      eventLabel: this.category.id
    });
  }
};
